import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import InputControl from './../FormTemplate/InputControl';
import axios from './../../constants/axios';
import alert from 'alertify.js';
import * as actions from './../../actions/sessionActions';

import { Button } from 'react-bootstrap';

class LoginForm extends React.Component {

   submit = (values) => {
      return axios
         .post('/sessions/login', values)
         .then((res) => {
            if (res.status === 201) {
               this.props.dispatch(actions.loginSuccess(res.data.user));
               actions.addTokenToSessionStorage(res.data.token);
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, pristine, invalid, error } = this.props;
      return (
         <form noValidate="true" autoComplete="off" onSubmit={handleSubmit(this.submit)} >

            <Field name="mobile" component={InputControl}
                   label="Mobile" />

            <Field name="password" component={InputControl} type="password"
                   label="Password" />
            {error && <strong className="input-validation-error" >{error}</strong>}
            <Button type="submit" bsStyle="success" block
                    disabled={submitting || pristine || invalid} >Login</Button>
         </form>
      );
   }
}

LoginForm.propTypes = {
   handleSubmit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
   ]),
   dispatch: PropTypes.func
};


LoginForm = reduxForm({ // eslint-disable-line
   form: 'loginForm'
})(LoginForm);

export default LoginForm;



/** WEBPACK FOOTER **
 ** ./src/components/Session/LoginForm.js
 **/